import { ActivatedRouteSnapshot } from "@angular/router";
import { BreadcrumbDisplayFunctions } from "@lib/base/components/navigation/breadcrumb/breadcrumb.component";
import { notNull } from "@lib/base/utils/object.utils";
import { doesSnapshotRouteExists } from "@lib/base/utils/routing.utils";

export const defaultBreadcrumbDisplay: BreadcrumbDisplayFunctions = (snapshot, url) => {
    return snapshot.pathFromRoot
        .flatMap(e => e.routeConfig?.path?.split("/"))
        .filter(notNull)
        .filter(e => e !== "")
        .map((urlSegment, i, self) => {
            const routeExists = doesSnapshotRouteExists(snapshot, self.slice(0, i + 1).join("/"));
            return {
                label: createDefaultLabel(urlSegment, snapshot, self, i),
                route: routeExists ? urlToAbsoluteRoute(url, i) : null,
            };
        });
};

const createDefaultLabel = (urlSegment: string, snapshot: ActivatedRouteSnapshot, urlSegments: string[], i: number) => {
    if (urlSegment.startsWith(":")) {
        const param = snapshot.paramMap.get(urlSegment.replace(":", ""));
        return decodeURIComponent(param ?? "");
    } else {
        const translateKey = urlSegments.filter(e => !e.startsWith(":")).slice(0, i + 1).join(".");
        return `routing.${translateKey}._title`;
    }
};

const urlToAbsoluteRoute = (url: string, i: number) => {
    const splitUrl = url.split("/")
        .filter(e => e !== "")
        .slice(0, i + 1)
        .join("/");
    return `/${splitUrl}`;
};
